import { useEffect, useRef, useState } from 'react';

import { Button, Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';

import PortfolioStakedCard from './card/PortfolioStakedCard';
import PortfolioDetailTable from './table/portfolio/PortfolioDetailTable';
import ClaimModal from './modal/ClaimModal';
import BigNumber from 'bignumber.js';
import CommonButton from './CommonButton';
import { portfolioStakedDetailColumns } from './table/ColumnsData';

import { useWeb3 } from '@/hooks/use-web3';
import { GETREWARDSCHEDULECOUNT, GETSTAKE, GETSTAKECOUNT, REWARDSCHEDULE } from '@/lib/common/name-space';
import { promiseAllSettled } from '@/lib/Promise';
import { ResClaimList } from '@/types';

export default function ClaimList({ contractAddr }: { contractAddr: string }) {
  const [list, setList] = useState<ResClaimList[] | null>(null);
  const [isOpenClaimModal, setIsOpenClaimModal] = useState(false);

  const rewardCnt = useRef(0);
  const address = useRef<string>('');

  const { web3authCall } = useWeb3();
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:900px)');

  useEffect(() => {
    if (list && list?.length > 0) {
      return;
    }
    (async () => {
      if (web3authCall?.connected()) {
        const addr = await web3authCall.getAddress();
        address.current = addr;
        const arr = [() => stateCount(), () => scheduleCount()];
        const counts = await promiseAllSettled(arr);
        rewardCnt.current = counts[1];
        const re = await mergeData(counts);
        setList(re);
      }
    })();
    return () => {};
  }, [web3authCall, contractAddr, address.current]);

  // 1. 풀에 스테이킹한 횟수
  const stateCount = async (): Promise<string> => {
    return web3authCall!.callStaking(GETSTAKECOUNT, contractAddr, [address.current]);
  };
  // 2. 보상 스케줄 전체 리스트 개수
  const scheduleCount = async (): Promise<string> => {
    return web3authCall!.callStaking(GETREWARDSCHEDULECOUNT, contractAddr);
  };
  // 5. 보상스케줄 및 사용자 스테이크 정보
  const mergeData = async (aSchedule: string[]): Promise<ResClaimList[]> => {
    let arrClaimSchedule = [];
    let arrStakeInfo = [];
    const arrResult = [];
    for (let y = 0; y < Number(aSchedule[0]); y++) {
      arrStakeInfo.push(() => web3authCall!.callStaking(GETSTAKE, contractAddr, [address.current, String(y)]));
      for (let i = 0; i < Number(aSchedule[1]); i++) {
        arrClaimSchedule.push(() => web3authCall!.callStaking(REWARDSCHEDULE, contractAddr, String(i)));
      }
      const claimSchedule = await promiseAllSettled(arrClaimSchedule);
      const stakeInfo = await promiseAllSettled(arrStakeInfo);
      const temp = claimSchedule.map((item: any) => ({
        ...item,
        ...stakeInfo[0],
        index: BigNumber(stakeInfo[0].amountStaked).plus(Math.random()),
      }));

      arrResult.push(temp);
      arrClaimSchedule = [];
      arrStakeInfo = [];
    }

    const re = arrResult.flat();

    return re;
  };

  // const handleClaimRewardIndex = async () => {
  //   const index = '2';
  //   const payload = [address.current, index];
  //   const re = await web3authCall?.callStaking(CLAIMREWARD, contractAddr, payload);
  //   console.log(re);
  // };
  return (
    <>
      <Box
        sx={{
          maxWidth: '1680px',
          padding: '16px 24px',
          marginTop: '16px',
          marginBottom: '38px',
        }}
      >
        {isMobile ? (
          <>
            {rewardCnt.current > 0 && (
              <>
                <Typography variant="h3" color={theme.greyscale.darkgrey2} sx={{ marginBottom: '16px' }}>
                  Reward Detail
                </Typography>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    setIsOpenClaimModal(true);
                  }}
                >
                  Claim All Reward
                </Button>
                <Box mb={3} />
              </>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {list && list.map((item: ResClaimList) => <PortfolioStakedCard key={item.index} item={item} />)}
            </Box>
          </>
        ) : (
          <>
            {/* <Button onClick={handleClaimRewardIndex}>claimReward</Button> */}
            <Grid container spacing={2}>
              <Grid xs={8}>
                <Typography variant="h3" color={theme.greyscale.darkgrey2} sx={{ marginBottom: '16px' }}>
                  Reward Detail
                </Typography>
              </Grid>
              <Grid xs>
                {rewardCnt.current > 0 && (
                  <CommonButton
                    sx={{ width: '100%', padding: '12px 20px', borderRadius: '10px' }}
                    text="Claim All Reward"
                    handleClick={() => {
                      setIsOpenClaimModal(true);
                    }}
                    variant="h6"
                    color={'#ffffff'}
                    bgColor={theme.background.blue}
                    border={theme.background.blue}
                  />
                )}
              </Grid>
            </Grid>
            {list && <PortfolioDetailTable list={list} columns={portfolioStakedDetailColumns} />}
          </>
        )}
      </Box>
      <ClaimModal open={isOpenClaimModal} handleClose={() => setIsOpenClaimModal(false)} contractAddr={contractAddr} />
    </>
  );
}
